// Component for displaying Oma's current capacity

import { motion } from 'framer-motion';
import type { CapacityLevel } from '../types';

interface CapacityIndicatorProps {
  capacity: CapacityLevel;
  onExtendCapacity: () => void;
}

const capacityColors: Record<CapacityLevel, string> = {
  deep: 'var(--color-capacity-deep)',
  sustained: 'var(--color-capacity-sustained)',
  limited: 'var(--color-capacity-limited)',
  minimal: 'var(--color-capacity-minimal)',
};

export function CapacityIndicator({ capacity, onExtendCapacity }: CapacityIndicatorProps) {
  return (
    <motion.div
      style={{
        position: 'fixed',
        bottom: 'var(--space-xl)',
        right: 'var(--space-xl)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 'var(--space-sm)',
        fontSize: 'var(--text-sm)'
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.5 }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-sm)'
      }}>
        <span style={{ color: 'var(--color-text-muted)' }}>capacity:</span>
        <span style={{ 
          fontWeight: 500,
          color: capacityColors[capacity],
          transition: 'color var(--transition-fast)'
        }}>
          {capacity}
        </span>
      </div>
      
      <button 
        onClick={onExtendCapacity}
        type="button"
        style={{
          color: 'var(--color-text-secondary)',
          fontSize: 'var(--text-xs)',
          transition: 'color var(--transition-fast)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--color-text-primary)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--color-text-secondary)';
        }}
      >
        [extend capacity]
      </button>
    </motion.div>
  );
}
